import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import MediaQueries from '../../../../styles/Grid/MediaQueries';

export const containerMarginCss = css(typography.effra18, {
  marginBottom: 57,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const bodyCopyCss = css(typography.effra18, {
  lineHeight: '30px',
  position: 'relative',
  marginBottom: 28,

  [MediaQueries.md]: {
    marginBottom: 22,
  },

  [MediaQueries.lgAndUp]: {
    marginBottom: 15,
  },
});

export const headlineCss = css(typography.effra18, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  marginBottom: 24,

  [MediaQueries.md]: {
    marginBottom: 32,
  },

  [MediaQueries.lgAndUp]: {
    marginBottom: 16,
  },
});

export const showLessCss = css({
  maxHeight: 390,
  overflow: 'hidden',
  [MediaQueries.md]: {
    maxHeight: 330,
  },
  [MediaQueries.lg]: {
    maxHeight: 360,
  },
  [MediaQueries.xl]: {
    maxHeight: 330,
  },

  '&::after': {
    content: '""',
    width: '100%',
    height: 50,
    position: 'absolute',
    bottom: 0,
    background:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
  },
});

export const richtextCss = css({
  p: {
    marginBottom: 30,

    '&:last-child': {
      marginBottom: 0,
    },
  },
});

export const NearbyLinkCss = css(typography.effra22, {
  color: colorsPalette.black,
  display: 'inline',
  paddingBottom: 2,
});

export const btnShowMoreLessCss = css(typography.effra12, {
  border: 'none',
  background: 'none',
  textDecorationLine: 'underline',
  padding: 0,
  color: colorsPalette.grey60,
  cursor: 'pointer',
});

export const showMoreLessTextCss = css(typography.effra12Link, {
  lineHeight: '20px',
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  display: 'inline-block',
});

export const showAllCss = css({
  [MediaQueries.smAndUp]: {
    maxHeight: '100%',
  },
  '&::after': {
    height: 0,
  },
});

export const iconCss = css({
  marginLeft: 8,
  fontSize: 8,
});

export const btnLessIconCss = {
  transform: 'rotate(180deg)',
};
